<template>
  <div>
    <div class="mt-32 px-12 pb-10 lg:px-0">
      <p class="text-xl font-bold">Balloon ID: ASNQ11-2DB4-6713</p>
    </div>
    <div class="flex flex-col xl:flex-row xl:justify-around ">
      <div class="flex flex-col xl:p-16 items-center" v-if="!presentImages">
        <img
          src="@/assets/images/reports.svg"
          alt=""
          class="h-full xl:w-2/3 w-full"
        />
        <p
          class="text-center text-base lg:text-4xl text-grayLight font-bold opacity-50 my-10"
        >
          Predictions are not being run at the moment please hold on.
        </p>
      </div>
      <img
        :src="presentImages"
        alt="log images"
        class="rounded-3xl h-full xl:w-2/3 w-full"
        v-else
      />
      <div class="xl:w-1/4 w-full mt-16 xl:mt-1">
        <div class="flex justify-center xl:justify-start w-full">
          <button
            class="bg-buttoncolor focus:outline-none text-base font-medium rounded-l-lg p-2 md:py-4 text-white shadow-xl w-full"
          >
            Stream console
          </button>
          <button
            class="rounded-r-lg focus:outline-none text-base font-medium p-2 md:py-4 bg-btnGray shadow-xl w-full"
          >
            <router-link to="/nav/a">Navigation console</router-link>
          </button>
        </div>

        <div class="parent bg-white shadow-lg rounded-t-lg mt-10">
          <div class="child">
            <button
              v-for="(prediction, i) in predictions"
              :key="i"
              class="focus:outline-none w-full py-8 px-6 text-left border-b border-lightGrayer"
              @click="changeImage(prediction.image)"
            >
              {{ prediction.prediction_time }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pusher from "pusher-js";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      presentImage: "",
      presentImages: ""
    };
  },
  methods: {
    changeImage(image) {
      this.presentImages = image;
    },
    ...mapActions({
      getPredictions: "events/getPredictions"
    }),
    pusherData() {
      console.log("Pusher");
      var pusher = new Pusher("c8ad5703cc985e1d2687", {
        cluster: "eu"
      });
      pusher.subscribe("spill-sat");
      pusher.bind("new-prediction", data => {
        console.log("An event was triggered");
        this.predictions.unshift(data);
        this.presentImages = data.image;
        console.log(data);
      });
    }
  },
  computed: {
    ...mapGetters({
      predictions: "events/predictions"
    })
  },
  created() {
    this.pusherData();
    this.getPredictions();
  }
};
</script>

<style lang="scss" scoped>
.parent {
  width: 100%;
  height: 35rem;
  overflow: hidden;
}
.child {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
  box-sizing: content-box;
}
// * {
//   scrollbar-width: thin;
//   scrollbar-color: #1d99b5;
// }

// /* Works on Chrome/Edge/Safari */
// *::-webkit-scrollbar {
//   width: 12px;
// }
// *::-webkit-scrollbar-track {
//   background: #8080808e;
// }
// *::-webkit-scrollbar-thumb {
//   background-color: #1d99b5;
//   border-radius: 20px;
//   // border: 3px solid orange;
// }
</style>
